import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { HowItWorks } from './pages/HowItWorks';
import { CaseStudies } from './pages/CaseStudies';
import { About } from './pages/About';
import { BookCall } from './pages/BookCall';
import { WhoWeServe } from './pages/WhoWeServe';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { WindowsCaseStudy } from './pages/WindowsCaseStudy';
import { MeetingsFlow } from './pages/onboarding/MeetingsFlow';
export function App() {
  useEffect(() => {
    // Meta Pixel Code - only initialize once
    if (window.fbq) {
      // Pixel already loaded, just track pageview
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize Meta Pixel for the first time
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '878753891400350');
    window.fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Routes data-id="element-2">
          {/* Hidden pages - no header/footer */}
          <Route path="/windows-case-study" element={<WindowsCaseStudy data-id="element-4" />} data-id="element-3" />
          <Route path="/onboarding/meetings" element={<MeetingsFlow data-id="element-6" />} data-id="element-5" />

          {/* Regular pages with header/footer */}
          <Route path="/*" element={<>
                <Header data-id="element-8" />
                <main className="flex-grow" data-id="element-9">
                  <Routes data-id="element-10">
                    <Route path="/" element={<Home data-id="element-12" />} data-id="element-11" />
                    <Route path="/how-it-works" element={<HowItWorks data-id="element-14" />} data-id="element-13" />
                    <Route path="/case-studies" element={<CaseStudies data-id="element-16" />} data-id="element-15" />
                    <Route path="/about" element={<About data-id="element-18" />} data-id="element-17" />
                    <Route path="/book-call" element={<BookCall data-id="element-20" />} data-id="element-19" />
                    <Route path="/who-we-serve" element={<WhoWeServe data-id="element-22" />} data-id="element-21" />
                    <Route path="/terms" element={<Terms data-id="element-24" />} data-id="element-23" />
                    <Route path="/privacy" element={<Privacy data-id="element-26" />} data-id="element-25" />
                  </Routes>
                </main>
                <Footer data-id="element-27" />
              </>} data-id="element-7" />
        </Routes>
      </div>
    </BrowserRouter>;
}